import React from "react";
import WarrantyBanner from "./WarrantyBanner";
import HighlightSpecs from "./HighlightSpecs";
import * as Styles from "./Highlights.styles";
import { useComponentRegistry } from "../../componentRegistry";

const Highlights = (): JSX.Element => {
    const LegalSpecifications = useComponentRegistry("LegalSpecifications");

    return (
        <Styles.Wrapper>
            <HighlightSpecs />
            <LegalSpecifications />
            <WarrantyBanner />
        </Styles.Wrapper>
    );
};

export default Highlights;
